import React, { Component } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import style from "./BookTime.module.css";
import DayPicker, { DateUtils } from "react-day-picker";
import TimeField from "react-simple-timefield";
import api from "../../utils/Api";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import moment from "moment";
import { isEmpty, getFormattedBookedTime } from "../../utils/CommonUtil";

export class BookTime extends Component {
  constructor(props) {
    super(props);

    this.state = {
      blockTimeData: [],
      reqProfessional: "",
      room: "",
      selectedDays: [],
      finalDaysSelection:[],
      showDatetime: true,
      isOpen: false,
      selectedDateTime: [],
      selectedtime: "00:00",
      professionalData: [],
      roomData: [],
      additionalNotes: "",
      isLoading: false,
      successMessage: "",
      errorMessage: "",
      reqProfError: "",
      roomError: "",
      dateError: "",
      selectedProfessional: "",
      selectedRoom: "",
      selectedEndtime: "00:00",
      isValid: false,
      isScreenLoaded: false
    };
  }

  componentDidMount() {
    document.title = 'Block Time - TechToMedix';
    this.fetchBlockTimeData();
  }

  // Fetch requested professional/doctor and room dropdown data
  fetchBlockTimeData = async () => {
    const headers = {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };
    try {
      const response = await api.get(
        "appointment/blockcalendar/dropdown/fetch",
        { headers: headers }
      );

      this.setState({
        blockTimeData: response.data.data,
        professionalData: response.data.data.requestedProfessional,
        roomData: response.data.data.room,
      });

      setTimeout(() => {
        this.setState({
          isScreenLoaded: true,
        });
    }, 200);


    } catch (error) {
      console.log("Error in block time fetch data", error);
    }
  };

  handleProfChange = (event) => {
    this.setState(
      {
        reqProfessional: event.target.value,
      },
      () => {
        this.getBlockTimePreData();
        if (this.state.reqProfessional === "") {
          this.setState({
            reqProfError: "Requested Professional/Doctor is required field",
          });
        } else {
          this.setState({
            reqProfError: "",
          });
        }
      }
    );
  };

  // handleRoomChange = (event) => {
  //   this.setState(
  //     {
  //       room: parseInt(event.target.value),
  //     },
  //     () => {
  //       this.getBlockTimePreData();
  //       if (this.state.room === "") {
  //         this.setState({
  //           roomError: "Room is required field",
  //         });
  //       } else {
  //         this.setState({
  //           roomError: "",
  //         });
  //       }
  //     }
  //   );
  // };

  getBlockTimePreData = () => {
    console.log(
      "getBlockTimePreData.state.reqProfessional ",
      this.state.reqProfessional
    );
    if (this.state.reqProfessional !== "") {
      let relatedPartyArr = this.state.blockTimeData.requestedProfessional.find(
        (element) => {
          return (
            element.related_party_id === Number(this.state.reqProfessional)
          );
        }
      );

      const blockappointmentTimeData = relatedPartyArr.blockappointment;
      let blockedTime = blockappointmentTimeData.find((element) => {
        return (
          element.requested_related_party_id == this.state.reqProfessional
        );
      });
      console.log("blockedTime", blockedTime);

      if (!isEmpty(blockedTime)) {
        const finalData = JSON.parse(blockedTime.blocked_datetime);
        console.log("finalData", finalData);
        const selectDateTimeArray =
          finalData &&
          finalData.filter(function (item, index) {
            const dateTime = new Date(item.bdate);
            dateTime.setHours(item.start.split(":")[0]);
            dateTime.setMinutes(item.start.split(":")[1]);
            return (
              !moment(dateTime).isBefore(Date.now(), "day") &&
              !moment(dateTime).isBefore(Date.now(), "hour") &&
              !moment(dateTime).isBefore(Date.now(), "minute")
            );
          });

        const notesData = blockedTime.notes;
        console.log("selectDateTimeArray", selectDateTimeArray);
        this.setState({
          selectedDateTime: selectDateTimeArray,
          additionalNotes: notesData,
        });
      } else {
        this.setState({
          selectedDateTime: [],
          additionalNotes: "",
        });
      }
    }
  };

  handleNotesChange = (event) => {
    this.setState({
      additionalNotes: event.target.value,
    });
  };

  handleProfBlurChange = () => {
    if (this.state.reqProfessional === "") {
      this.setState({
        reqProfError: "Requested Professional/Doctor is required field",
      });
    } else {
      this.setState({
        reqProfError: "",
      });
    }
  };

  // handleRoomBlurChange = () => {
  //   if (this.state.room === "") {
  //     this.setState({
  //       roomError: "Room is required field",
  //     });
  //   } else {
  //     this.setState({
  //       roomError: "",
  //     });
  //   }
  // };

  handlerTimeChange = (event, value) => {
    const val = event.target.value;
    const name = event.target.name;
    this.setState({
      [name]: val,
    });
  };

  handleDayClick = (day, modifiers = {}) => {
     if (modifiers.disabled) {
      return;
    }
    const { selectedDays } = this.state;
    if (modifiers.selected) {
      const selectedIndex = selectedDays.findIndex((selectedDay) =>
        DateUtils.isSameDay(selectedDay, day)
      );
      selectedDays.splice(selectedIndex, 1);
    } else {
      selectedDays.push(day);
    }
    console.log("selectedDays", selectedDays);
    this.setState({ selectedDays });
  };

  toggle = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
      calendarErrorMessage: "",
    }));
  };

  save = () => {
    const selectedDateTime = this.state.selectedDateTime;
    const selectedTime = this.state.selectedtime;
    const selectedEndTime = this.state.selectedEndtime;

    // console.log("selectedTime>>", selectedTime);
    // console.log("selectedEndTime>>", selectedEndTime);
    // console.log("selectedDateTime>>",  new Date().toLocaleTimeString);
    // console.log("selectedData>>",  this.state.selectedDays);

    if( this.state.selectedDays.length === 0){
      this.setState({
        calendarErrorMessage: "Please select a date to proceed!",
      });
      return false;
    }
    //checking if selected date and time is of future or not.
    let startTimeInString = selectedTime.replace(":","");
    let endTimeInString = selectedEndTime.replace(":","");
    let currentTimeInString = new Date().toLocaleTimeString('en-US', { hour12: false, 
      hour: "numeric", 
      minute: "numeric"})
    let date = new Date();
    currentTimeInString = currentTimeInString.replace(":","");
    let dateError =  this.state.selectedDays.find((item, index)=>
    (item.toLocaleDateString() === date.toLocaleDateString()) && 
    ((parseInt(startTimeInString) < parseInt(currentTimeInString)) ||
    (parseInt(endTimeInString) < parseInt(currentTimeInString)))
    )

    if(dateError){
      this.setState({
        calendarErrorMessage: "Please select future time!",
      });
      return false;
    }
    
    if (this.state.selectedEndtime < this.state.selectedtime) {
      this.setState({
        calendarErrorMessage: "End time value cannot be before start time!",
      });
      return false;
    }

    if (this.state.selectedEndtime === this.state.selectedtime) {
      this.setState({
        calendarErrorMessage: "Start time and end time cannot be same!",
      });
      return false;
    }

    //checking for same time slot selection
    if (this.state.selectedDateTime.length > 0) {
      let sameSlot;
      let selectedstartdatetime;
      let selectedenddatetime;
     const slotDate = this.state.selectedDateTime.find((element) => {
        const bookedStartDateTime = getFormattedBookedTime(element.bdate, element.start);
        const bookedEndDateTime = getFormattedBookedTime(element.bdate, element.end);
        sameSlot = this.state.selectedDays.find((selectedDay)=> {
              selectedstartdatetime = getFormattedBookedTime(selectedDay, selectedTime);
              selectedenddatetime = getFormattedBookedTime(selectedDay, selectedEndTime);
             
              return !!((selectedstartdatetime > bookedStartDateTime && selectedstartdatetime < bookedEndDateTime)||
              (selectedenddatetime > bookedStartDateTime && selectedstartdatetime < bookedEndDateTime));
              } )
        if(sameSlot){
          return true
        }
      })
           
      if(sameSlot){
        this.setState({
          calendarErrorMessage:
            "This time slot is already selected. Please select different slot!",
        });
        return true;
      }
    }

    // if(this.state.finalDaysSelection.length > 0){
    //   let startTimeInString = selectedTime.replace(":","");
    //   let endTimeInString = selectedEndTime.replace(":","");
    //   this.state.selectedDays.map((currentSelection, index)=>{
    //     if(this.state.finalDaysSelection.indexof(currentSelection) > -1){

    //     }
    //     let currentTimeInString = currentSelection.toLocaleTimeString('en-US', { hour12: false, 
    //       hour: "numeric", 
    //       minute: "numeric"})
    //     currentTimeInString = currentTimeInString.replace(":","");
    //     let dateError =  this.state.selectedDays.find((item, index)=>
    //       (item.toLocaleDateString() === currentSelection.toLocaleDateString()) && 
    //       ((parseInt(startTimeInString) < parseInt(currentTimeInString)) ||
    //       (parseInt(endTimeInString) < parseInt(currentTimeInString)))
    //       )
    //   }
    // }


    const selectedData = [...this.state.selectedDays];
    // this.setState({
    //   finalDaysSelection: [...this.state.selectedDays]
    // })
    const data = selectedData.map((day) => {
      // day.setHours(selectedTime.split(":")[0]);
      // day.setMinutes(day.getMinutes() + selectedTime.split(":")[1]);
      return {
        bdate: day.toISOString(),
        start: selectedTime,
        end: selectedEndTime,
      };
    });

    // let same = false;
    // const dataString = data.map((day) => (
    //   same = this.state.finalDaysSelection.find((item)=>
    //     JSON.stringify(day) === JSON.stringify(item)
    //   )
    // ));


    selectedDateTime.push(...data);
    
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
      selectedDateTime,
      selectedDays:[]
    }));
    if (selectedDateTime.length > 0) {
      this.setState({
        dateError: "",
      });
    } else {
      this.setState({
        dateError: "Choose date and time required!",
      });
    }
  };

  removeSelectedDate = (index) => {
    const selectedDateTime = [...this.state.selectedDateTime];
    if (selectedDateTime.length > 0) {
      selectedDateTime.splice(index, 1);
      this.setState({ selectedDateTime });
    }
  };

  renderScheduledTime(dateValue, timeValue) {
    const datetime = new Date(dateValue);
    datetime.setHours(timeValue.split(":")[0]);
    datetime.setMinutes(datetime.getMinutes() + timeValue.split(":")[1]);
    return datetime.toLocaleTimeString();
  }

  renderScheduledDates() {
    if (this.state.selectedDateTime.length > 0) {
      return (
        <div className="col-lg-12">
          <p>Here is the booked date(s) and time slot(s)</p>
          {this.state.selectedDateTime.map((item, index) => (
            <div key={index} className={style.inlineDateTimeInnerWrapper}>
              <span key={index} className={style.dateInfo}>
                {/* {new Date(item.bdate).toLocaleDateString()} */}
                {moment(item.bdate).format("YYYY-MM-DD")}{" "}
                {this.renderScheduledTime(item.bdate, item.start)}
                {" - "}
                {this.renderScheduledTime(item.bdate, item.end)}
                <i
                  className={`fa fa-times ${style.faRemove}`}
                  aria-hidden="true"
                  onClick={() => this.removeSelectedDate(index)}
                ></i>
              </span>
            </div>
          ))}
        </div>
      );
    }
  }

  // Reseting form input fields
  resetForm = () => {
    this.setState({
      selectedDateTime: [],
      room: "",
      reqProfessional: "",
      selectedTime: "",
      additionalNotes: "",
    });
    // this.blockedTimeFormRef.reset();
  };

  // Check validations
  checkValid = () => {
    if (this.state.reqProfessional === "") {
      this.setState({
        reqProfError: "Requested Professional/Doctor is required field",
        isValid: false,
      });
      return false;
    } else {
      this.setState({
        reqProfError: "",
        isValid: true,
      });
    }

    // if (this.state.room === "") {
    //   this.setState({
    //     roomError: "Room is required field",
    //     isValid: false,
    //   });
    //   return false;
    // } else {
    //   this.setState({
    //     roomError: "",
    //     isValid: true,
    //   });
    // }

    if (this.state.selectedDateTime.length === 0) {
      this.setState({
        dateError: "Date and time is required ",
        isValid: false,
      });
      return false;
    } else {
      this.setState({
        dateError: "",
        isValid: true,
      });
    }
    return true;
  };

  // Submitting block time data
  onSubmit = async () => {
   let isValid = this.checkValid();
    if (isValid === true) {
      const payload = {
        requested_related_party_id: Number(this.state.reqProfessional),
        notes: this.state.additionalNotes,
        blocked_datetime: this.state.selectedDateTime,
      };
      const headers = {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
      };
      try {
        const response = await api.post("appointment/blockcalendar", payload, {
          headers: headers,
        });
        if (response.status === 200) {
          this.fetchBlockTimeData();
          this.setState({
            isLoading: false,
            successMessage: "Block Time in Calendar saved sucessfully!",
          });
          setTimeout(() => {
            this.setState({
              successMessage: "",
            });
            this.resetForm();
          }, 2000);
        }
      } catch (error) {
        console.log("Error in block time save ", error);
        this.setState({
          isLoading: false,
          errorMessage: "Error!",
        });
        setTimeout(() => {
          this.setState({
            errorMessage: "",
          });
        }, 2000);
      }
    }
  };

  render() {
    console.log("this.state.selectedDays", this.state.selectedDays);
    const { professionalData, roomData } = this.state;
    // Getting requested professional data
    const reqProfessionalData = professionalData.map((element, index) => (
      <option key={index} value={element.related_party_id}>
        {element.name}
      </option>
    ));
    // Getting room data
    // const reqroomData = roomData.map((element, index) => (
    //   <option key={index} value={element.room_id}>
    //     {element.room_name}
    //   </option>
    // ));
    if(!this.state.isScreenLoaded){
      return(
      <div className="dashboard-loader">
            <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
        );
  }
    return (
      <div className={style.bookTimeMainWrapper}>
        <div className="row">
          <div className="col-lg-12">
            <h3>Block Time</h3>
          </div>
          <div className="col-lg-12 intro-text">
            <p className="mb-4">
            Block out a period in a Professional/Doctor's dairy when s/he will not be available for Appointments. 
            The dates and times must be selected.
            </p>
          </div>
        </div>
        <form ref={(el) => (this.blockedTimeFormRef = el)}>
          <div className="form-box-shadow">
            <div className="row">
              <div className="col-md-6 col-xl-4">
                <div className="form-group">
                  <label htmlFor="reqProfessional">
                    Requested Professional/Doctor
                    <span className="mandatory">
                      <small>*</small>
                    </span>
                  </label>
                  <select
                    id="reqProfessional"
                    name="reqProfessional"
                    onChange={this.handleProfChange}
                    onBlur={this.handleProfBlurChange}
                    className={`form-control ${
                      this.state.reqProfError ? "is-invalid" : ""
                    }`}
                    value={
                      this.state.reqProfessional
                        ? this.state.reqProfessional
                        : ""
                    }
                  >
                    <option value="">Select Professional</option>
                    {reqProfessionalData}
                  </select>
                  {this.state.reqProfError && (
                    <span className="error">{this.state.reqProfError}</span>
                  )}
                </div>
              </div>
              {/* <div className="col-md-6 col-xl-4">
                <div className="form-group">
                  <label htmlFor="room_location">For Room/Location</label>
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                  <select
                    className="form-control"
                    id="room"
                    name="room"
                    onChange={this.handleRoomChange}
                    onBlur={this.handleRoomBlurChange}
                    className={`form-control ${
                      this.state.roomError ? "is-invalid" : ""
                    }`}
                    value={this.state.room ? this.state.room : ""}
                  >
                    <option value="">Select Room</option>
                    {reqroomData}
                    <option value="0">None</option>
                  </select>
                  {this.state.roomError && (
                    <span className="error">{this.state.roomError}</span>
                  )}
                </div>
              </div> */}
             
            {/* </div>
            <div className="row"> */}
              <div className="col-md-6 col-xl-4">
                <div className="form-group">
                <label htmlFor="choose_date">Choose Date and Time</label>
                  <span className="mandatory">
                    <small>*</small>
                  </span>
                  <Button
                    className={`ttm-primary-btn ${
                      this.state.dateError ? "is-invalid" : ""
                    }`}
                    onClick={this.toggle}
                    disabled={!this.state.reqProfessional}
                  >
                    <i className="fa fa-calendar mr-1"></i> Choose date and Time
                  </Button>

                  {this.state.dateError && (
                    <span className={`error ${style.dateError}`}>
                      {this.state.dateError}
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="row">{this.renderScheduledDates()}</div>
            <div className="row">
              <div className="col-lg-8 col-xl-8">
                <div className="form-group">
                  <label htmlFor="add_notes">Additional Notes</label>
                  <textarea
                    className="form-control"
                    rows={3}
                    id="additionalNotes"
                    name="additionalNotes"
                    value={this.state.additionalNotes}
                    onChange={this.handleNotesChange}
                  />
                </div>
              </div>
            </div>
          </div>
          <div
            className={`d-flex justify-content-center justify-content-sm-end ${style.btnWrapper}`}
          >
            {/* <button type="button" className="ttm-primary-btn">
              Back
            </button> */}
            <button
              type="button"
              className="ttm-primary-btn mb-3"
              onClick={this.onSubmit}
            >
              Save
            </button>
          </div>
          <div className="row">
            <div className="col-md-12">
              {this.state.isLoading ? (
                <div className={style.loadingWrapper}>
                  <img src={ttmLoader} className={style.loading} />
                </div>
              ) : (
                <div>
                  {this.state.successMessage && (
                    <p className={style.successMessage}>
                      {this.state.successMessage}
                    </p>
                  )}
                  {this.state.errorMessage && (
                    <p className={style.errorMessage}>
                      {this.state.errorMessage}
                    </p>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Modal for datetime picker */}
          <div>
            <Modal
              isOpen={this.state.isOpen}
              toggle={this.toggle}
              className={style.dateTimeModal}
              centered
            >
              <ModalHeader
                toggle={this.toggle}
                className={style.deleteModalHeader}
              >
                Block Time :
              </ModalHeader>
              <ModalBody className={style.dateTimeModalBody}>
                <form>
                  {this.state.showDatetime && (
                    <div className="row">
                      <div className="col-lg-6 text-center text-lg-left mb-3">
                        <label className={style.datetimeLabel}>
                          Choose Date
                        </label>
                        <DayPicker
                          initialMonth={
                            new Date(
                              new Date().getFullYear(),
                              new Date().getMonth()
                            )
                          }
                          fromMonth={
                            new Date(
                              new Date().getFullYear(),
                              new Date().getMonth()
                            )
                          }
                          selectedDays={this.state.selectedDays}
                          disabledDays={[{ before: new Date() }]}
                          onDayClick={this.handleDayClick}
                        />
                      </div>
                      <div
                        className={`col-lg-6 text-center text-lg-left mb-3 ${style.timePickerWrapper}`}
                      >
                        <label className={style.datetimeLabel}>
                          Choose Time <br />
                          <small>24 Hours Time format</small>
                        </label>
                        {/* <div className="row">
                          <div className="col-lg-6">
                            <label>Start Time</label>
                          </div>
                          <div className="col-lg-6">
                            <label>End Time</label>
                          </div>
                        </div> */}
                        <div className="row">
                          <div className="col-lg-6 mb-2">
                            <label className="mr-2 text-left">Start Time</label>
                            <TimeField
                              style={{ width: "80%", height: "10%" }}
                              value={this.state.selectedtime} // {String}   required, format '00:00' or '00:00:00'
                              onChange={this.handlerTimeChange} // {Function} required
                              // {/* input={<MyCustomInputElement />}*/}// {Element}  default: <input type="text" />
                              colon=":" // {String}   default: ":"
                              showSeconds={false} // {Boolean}  default: false
                              name={"selectedtime"}
                            />
                          </div>
                          <div className="col-lg-6 mb-2">
                            <label className="mr-2 text-left">End Time</label>
                            <TimeField
                              style={{ width: "80%", height: "10%" }}
                              name={"selectedEndtime"}
                              value={this.state.selectedEndtime} // {String}   required, format '00:00' or '00:00:00'
                              onChange={this.handlerTimeChange} // {Function} required
                              // {/* input={<MyCustomInputElement />}*/}// {Element}  default: <input type="text" />
                              colon=":" // {String}   default: ":"
                              showSeconds={false} // {Boolean}  default: false
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </form>
                <div className={style.bookedTimeShowWrapper}>
                  <p className={style.errorMessage}>
                    {this.state.calendarErrorMessage}
                  </p>
                </div>
              </ModalBody>
              <ModalFooter className={style.dateTimeBtnWrapper}>
                <Button
                  onClick={this.toggle}
                  className="tmed-btn tmed-primary-btn"
                >
                  Cancel
                </Button>
                <Button
                  onClick={this.save}
                  className="tmed-btn tmed-primary-btn"
                >
                  Save
                </Button>
              </ModalFooter>
            </Modal>
          </div>
        </form>
      </div>
    );
  }
}

export default BookTime;
